import { render, staticRenderFns } from "./CompartirInformacionModalNuevo.vue?vue&type=template&id=333b2f9a&scoped=true&"
import script from "./CompartirInformacionModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./CompartirInformacionModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./CompartirInformacionModalNuevo.vue?vue&type=style&index=0&id=333b2f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333b2f9a",
  null
  
)

export default component.exports